import styled from 'styled-components'
import isString from 'lodash/isString'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import { Container } from '@components/styled'
import { H5 } from '@components/Heading'
import { windowLoadWithTimetout } from '@utils/timeout'
import { useEffect, useRef } from 'react'
import { TextBlock as TextContainer } from '@components/content'

const Block = styled(Container)`
  max-width: 68.8rem;
  transform: scale(0.8);
  opacity: 0;
`

interface TextBlockProps {
  title?: string
}

const TextBlock: React.FC<TextBlockProps> = ({ children, title }) => {
  const blockRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger)

    windowLoadWithTimetout(() => {
      const container = blockRef.current as HTMLDivElement

      ScrollTrigger.create({
        trigger: container as Element,
        start: '30% bottom',
        once: true,
        onEnter: (self) => {
          gsap.to(self.trigger?.firstChild as gsap.TweenTarget, {
            scale: 1,
            ease: 'power4.out',
            duration: 0.6,
          })

          gsap.to(self.trigger?.firstChild as gsap.TweenTarget, {
            opacity: 1,
            ease: 'power3.out',
            duration: 0.4,
          })
        },
      })
    })
  }, [])

  return (
    <div ref={blockRef}>
      <Block>
        {isString(title) && (
          <H5 className="mt-0 mb-16" as="h4">
            {title}
          </H5>
        )}
        <TextContainer>{children}</TextContainer>
      </Block>
    </div>
  )
}

export default TextBlock
